import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import theme from 'theme/ThemeContext';

const CustomAutocomplete = ({
  name,
  options,
  value,
  onChange,
  onInputChange,
  onBlur,
  error,
  helperText,
  placeholder,
  id,
  InputProps: inputProps = {},
  sx,
  ...rest
}) => {
  return (
    <Autocomplete
      options={options}
      value={value}
      onChange={onChange}
      onInputChange={onInputChange}
      {...rest}
      sx={{
        '& .MuiOutlinedInput-root': {
          // padding: '2px 5px !important'
          paddingTop: '2px !important',
          paddingBottom: '2px !important',
        },
        ...sx
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          name={name}
          placeholder={placeholder}
          error={Boolean(error)}
          helperText={helperText}
          onBlur={onBlur}
          InputProps={{
            ...params.InputProps,
            ...inputProps,
            sx: {
              '& .MuiInputBase-input': {
                padding: '8px 12px',
              },
              borderRadius: theme.formFileds.borderRadius,
              // height: theme.formFileds.height,
              ...inputProps.sx,
            },
          }}
        />
      )}
    />
  );
};

export default CustomAutocomplete;